import { createContext } from 'react'

import type { ModuleAvailabilityType } from 'modules/core/hooks/useModuleAvailability'

import type SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'

export interface ContextProps {
  moduleAvailabilities: ModuleAvailabilityType[]
  enpsInstalled: boolean
  enpsSubscription: SubscriptionAddon | undefined
  surveysInstalled: boolean
  surveysSubscription: SubscriptionAddon | undefined
  upsellFlowEnabled: boolean
  loading: boolean
  canCreateForms: boolean
  canCreateTemplates: boolean
  canManageSurveys: boolean
  canCreateEverybody: boolean
  canCreateReportees: boolean
  canCreateTeam: boolean
  canCreateOwned: boolean
}

export const EngagementContext = createContext<ContextProps | null>(null)
